import { goRequest } from '../utils/httpClientTs';

const BASE = '/api/notices';

export interface NoticeListItem {
  id: string;
  title: string;
  description: string;
  link_url?: string | null;
  due_date?: string | null;
  allow_clear_on_click: number;
  created_at?: string | null;
  recipient_group_type_ids?: string[];
  recipient_names?: string[];
}

export interface NoticeResponse {
  id: string;
  title: string;
  description: string;
  link_url?: string | null;
  due_date?: string | null;
  allow_clear_on_click: number;
  created_at?: string | null;
  updated_at?: string | null;
  recipient_group_type_ids?: string[];
  recipient_names?: string[];
}

export interface CreateNoticeRequest {
  title: string;
  description: string;
  link_url?: string;
  expiry_date: string; // ISO date or datetime
  recipient_group_type_ids: string[];
}

export interface UpdateNoticeRequest {
  title?: string;
  description?: string;
  link_url?: string;
  expiry_date?: string;
  allow_clear_on_click?: number;
}

export interface ListNoticesParams {
  page?: number;
  per_page?: number;
  active?: 'true' | 'false' | 'all';
}

export interface ListNoticesResult {
  items: NoticeListItem[];
  total_count: number;
  page: number;
  per_page: number;
}

export const listNotices = (
  params?: ListNoticesParams
): Promise<ListNoticesResult> => {
  const search = new URLSearchParams();
  if (params?.page != null) search.set('page', String(params.page));
  if (params?.per_page != null) search.set('per_page', String(params.per_page));
  if (params?.active) search.set('active', params.active);
  const q = search.toString();
  return goRequest<ListNoticesResult>({
    url: `${BASE}${q ? `?${q}` : ''}`,
    method: 'GET',
  });
};

export const getNotice = (id: string): Promise<NoticeResponse> =>
  goRequest<NoticeResponse>({ url: `${BASE}/${id}`, method: 'GET' });

export const createNotice = (
  body: CreateNoticeRequest
): Promise<NoticeResponse> =>
  goRequest<NoticeResponse>({ url: BASE, method: 'POST', data: body });

export const updateNotice = (
  id: string,
  body: UpdateNoticeRequest
): Promise<NoticeResponse> =>
  goRequest<NoticeResponse>({
    url: `${BASE}/${id}`,
    method: 'PATCH',
    data: body,
  });

export const deleteNotice = (id: string): Promise<void> =>
  goRequest<void>({ url: `${BASE}/${id}`, method: 'DELETE' });
